
const readOnly = {
    type: Boolean,
    default: false
}
const inputType = {
    type: String,
    default: 'string'
}
const label = {
    type: String,
    default: ''
}
const placeholder = {
    type: String,
    default: '请输入内容'
}
const value = {
    default: ''
}
const labelWidth = {
    type: [Number, String],
    default: 100
}
const labelPaddingRight = {
    type: [Number],
    default: 32
}
const disabled = {
    type: Boolean,
    default: false
}
const textAlign = {
    type: String,
    default: 'right'
}
const isRequire = {
    type: Boolean,
    default: false
}
const rows = {
    type: Number,
    default: 2
}
// 1 -> 底部有横线
const styleType = {
    type: [Number, String],
    default: 1
}

const isDipatch = {
    type: Boolean,
    default: false
}
const dipatchObj = {
    type: Object,
    default: () => ({})
}
const dipatchAttr = {
    type: String,
    default: ''
}
const multiple = {
    type: Boolean,
    default: false
}
const icon = {
    type: String,
    default: null
}

const isDipatchStyle = {
    type: Boolean,
    default: true
}

const min = {
    type: Number,
    default: null
}
const autofocus = {
    type: Boolean,
    default: false
}
// 基础常用组件2.0 2019-4-3
// 布局组件
export const layout = {
    icon,
    labelWidth,
    labelPaddingRight,
    label,
    readOnly,
    value,
    textAlign,
    styleType,
	isRequire,
	isDipatchStyle,
    dipatchObj, // 兼容原本的dipatch方式更新数据
    isDipatch, // 兼容原本的dipatch方式更新数据
    dipatchAttr // 兼容原本的dipatch方式更新数据
}

// string
export const string = {
    placeholder,
    disabled,
    readOnly,
    value,
    rows,
    min,
    autofocus,
    ...layout
}

// select
export const select = {
    placeholder,
    disabled,
    readOnly,
    value,
    multiple,
    ...layout
}

// 级联选择
export const cascader = {
    placeholder,
    disabled,
    readOnly,
    ...layout
}

// 日期选择器
export const datePicker = {
    placeholder,
    disabled,
    readOnly,
    ...layout
}

// 时间选择器
export const dateTimer = {
    placeholder,
    disabled,
    readOnly,
    ...layout
}

// 多选
export const baseCheckbox = {
    placeholder,
    disabled,
    readOnly,
    ...layout
}

export const autocomplete = {
    placeholder,
    disabled,
    readOnly,
    ...layout
}

export const upload = {
    placeholder,
    disabled,
    readOnly,
    ...layout
}

// 基础常用组件1.0(请不要用) 2019-4-3
// 旧组件 基本废弃
export const baseInput = {
    readOnly,
    inputType,
    label,
    placeholder,
    value,
    labelWidth,
    disabled
}




export function handleEmitValue(val) {
    this.$emit('handleEmitValue', val)
}

export function handleEmitBlur(selectItem) {
    this.$emit('handleBlur', selectItem)
}
export function handleEmitEnter(val) {
    this.$emit('handleEmitEnter', val)

}
